import { useEffect, useState, useCallback } from 'react';
import { useParams, useHistory } from 'react-router-dom';
import { updateTechnician, getTechnicianById } from '../../api/technicians';

import Input from '../../components/input/input';
import Textarea from '../../components/textarea/textarea';
import Select from '../../components/select/select';

import { ReactComponent as ArrowRightSVG } from '../../icons/arrow-right.svg';

import { COUNTRIES } from '../../config/country';

const TechnicianEdit = () => {
  const [loading, setLoading] = useState(false);
  const [technician, setTechnician] = useState(null);
  const { id } = useParams();
  const history = useHistory();

  const getData = useCallback(async () => {
    setLoading(true);
    const data_ = await getTechnicianById(id);
    setTechnician(data_);
    setLoading(false);
  }, [id]);

  const onChange = useCallback(
    (e) => {
      const { name, value } = e.target;

      setTechnician({
        ...technician,
        [name]: value,
      });
    },
    [technician],
  );

  const onSelectChange = useCallback(
    (field, selectedOption) => {
      setTechnician({
        ...technician,
        [field]: selectedOption,
      });
    },
    [technician],
  );

  const onSubmit = useCallback(async () => {
    setLoading(true);
    await updateTechnician(id, {
      ...technician,
      country: technician.country?.value,
    });
    history.push('/technicians');
  }, [history, id, technician]);

  useEffect(() => {
    getData();
  }, [getData]);

  if (loading || !technician) return <main className="th-main"></main>;

  return (
    <main className="th-main">
      <section className="th-canvas">
        <header className="th-canvas-header post-header">
          <h2 className="th-canvas-title">
            <span className="pointer" onClick={() => history.goBack()}>
              Go Back
            </span>
            <span>
              <ArrowRightSVG />
            </span>
            {technician.firstName} {technician.lastName}
          </h2>

          <section className="view-actions">
            <button className="btn-green" data-cy="submit" onClick={onSubmit}>
              <span>Save</span>
            </button>
          </section>
        </header>
        <div>
          <h4 className="midlightgrey f-small fw5 ttu mt15">Details</h4>
          <div className="pa5 pt4 br4 shadow-1 bg-grouped-table mt2 flex flex-column items-start justify-between">
            <div className="w-100 flex flex-column">
              <div className="w-100 flex flex-row items-start justify-between margin-between">
                <div className="w-66">
                  <div className="w-100 flex flex-row justify-between margin-between">
                    <div className="w-50">
                      <Input
                        name="firstName"
                        label="First name*"
                        value={technician.firstName}
                        valid={true}
                        onChange={(event) => onChange(event)}
                      />
                    </div>
                    <div className="w-50">
                      <Input
                        name="lastName"
                        label="Last name*"
                        value={technician.lastName}
                        valid={true}
                        onChange={(event) => onChange(event)}
                      />
                    </div>
                  </div>
                  <div className="w-100 flex flex-row justify-between margin-between">
                    <div className="w-50">
                      <Input
                        name="email"
                        label="Email*"
                        value={technician.email}
                        valid={true}
                        onChange={(event) => onChange(event)}
                      />
                    </div>
                    <div className="w-50">
                      <Input
                        name="phone"
                        label="Phone number*"
                        value={technician.phone}
                        valid={true}
                        onChange={(event) => onChange(event)}
                      />
                    </div>
                  </div>
                  <div className="w-100 flex flex-row justify-between margin-between">
                    <div className="w-50">
                      <Select
                        className="country-select"
                        valid={true}
                        isMulti={false}
                        label="Select country*"
                        value={technician.country}
                        options={COUNTRIES}
                        onChange={(selectedOption) =>
                          onSelectChange('country', selectedOption)
                        }
                      />
                    </div>
                    <div className="w-50">
                      <Input
                        name="city"
                        label="City*"
                        value={technician.city}
                        valid={true}
                        onChange={(event) => onChange(event)}
                      />
                    </div>
                  </div>
                  <div className="w-100 flex flex-row justify-between margin-between">
                    <Input
                      name="address"
                      label="Address*"
                      value={technician.address}
                      valid={true}
                      onChange={(event) => onChange(event)}
                    />
                  </div>
                  <div className="w-100 flex flex-row justify-between margin-between">
                    <Textarea
                      name="notes"
                      label="Additional notes"
                      value={technician.notes}
                      valid={true}
                      onChange={(event) => onChange(event)}
                    />
                  </div>
                </div>
              </div>
              <div className="w-100 flex flex-row items-start justify-between margin-between">
                <div className="w-66"> </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
};

export default TechnicianEdit;
